<template>
    <div class="detail">
        <div class="detail-l">
            <a href="javascript:;" class="goback-link" @click="router.back()">返回上一页</a>
            <p class="title">数字藏品详情</p>
            <p class="sub-title">DIGITAL COLLECTION INTRODUCTION</p>
            <div class="line">
                <i class="line-base"></i>
                <i class="line-point"></i>
            </div>
            <div class="info-box">
                <p class="label">交易哈希</p>
                <p class="value" style="height: 77rem">{{hash}}</p>
                <p class="label">链上确认时间</p>
                <p class="value">{{timestamp}}</p>
                <!-- <p class="label">所属合约</p>
                <p class="value">{{chaincodeName}}</p>
                <p class="label label-last">合约版本</p>
                <p class="value value-last">{{version}}</p> -->
            </div>
        </div>
        <div class="detail-r">
            <div class="r-box r-box1">
                <img src="@/assets/detail/height-icon.png" class="height-icon" alt=""> 藏品区块高度
                <!-- <span class="height-num">{{height}}</span> -->
                <span class="height-num"><ScrollNumber :end="`${height}`" /></span>
                <div class="box-border"></div>
            </div>
            <div class="r-box r-box2" style="margin-top: 34rem">
                <img src="@/assets/detail/block.png" class="detail-img" alt="">
                <img src="@/assets/detail/shadow.png" class="shadow" alt="">
                <div class="box-border"></div>
            </div>
        </div>
    </div>
</template>
<script>
import router from '@/router'
import ScrollNumber from '../components/ScrollNumber.vue'
import { getDetail } from '@/api/index'
import { reactive, toRefs } from '@vue/reactivity';
import { onBeforeMount, onUnmounted } from '@vue/runtime-core';
export default {
    components: {ScrollNumber},
    setup() {
        console.log('router', router)
        const hash = router.currentRoute._value.query.hash;
        const params = router.currentRoute._value.params
        
        const state = reactive({
            height: 0,
            hash: '--',
            timestamp: '--',
            chaincodeName: '--',
            version: '--'
        })
        onBeforeMount(async()=>{
            document.body.className += ' detail-body'
            let info = {}
            if(params?.hash){
                
                info = params
            }else if(hash){
                try {
                    const {data} = await getDetail({
                        hash
                    })
                    info = data
                } catch (error) {
                    alert(error.msg || '网络故障，请重试')
                }
                
            }
            for(var key in info){
                state[key] = info[key]
            }
            
        })
        
        onUnmounted(()=>{
            document.body.className = document.body.className.replace(' detail-body', '')
        })
        return {
            router,
            ...toRefs(state),
            // ScrollNumber
        }
    }
}
</script>
<style scoped>
@font-face {
    font-family: "akrobat";
    src:url('~@/assets/Akrobat-ExtraBold.ttf');
}
::v-global(.detail-body){
    background: #070A1F url('~@/assets/detail/bg.png') center bottom no-repeat;
    /* background-size: 100% auto; */
    background-size: cover;
}
.detail{
    display: flex;
    color: #fff;
}
.detail-l{
    width: 541.6rem;
    margin-right: 217rem;
}
.goback-link{
    display: block;
    /* margin-top: 66rem; */
    font-size: 19.2rem;
    line-height: 28.8rem;
    color: #1B5BDC;
    opacity: 0.8;
}
.goback-link:hover{
    opacity: 1;
}
.title{
    margin-top: 19rem;
    font-size: 34rem;
    line-height: 34rem;
}
.sub-title{
    font-size: 16rem;
    line-height: 22rem;
    margin-top: 10rem;
    opacity: 0.6;
}
.line{
    margin-top: 40rem;
    position: relative;
    
}
.line-base{
    position: absolute;
    width: 100%;
    height: 1px;
    top: 1px;
    left: 0;
    background: rgba(255, 255, 255, 0.4);
}
.line-point{
    position: absolute;
    left: 0;
    top: 0;
    width: 32rem;
    height: 3px;
    background: #fff;
}

.detail-r{
    /* margin-top: 70rem; */
    width: 558rem;
    color: #E0F2FD;
}
.r-box{
    background: rgba(9, 37, 94, 0.3);
    border-radius: 2px;
    border: 2px solid #123E98;
    position: relative;
}
.r-box1{
    padding: 22rem;
    display: flex;
    align-items: center;
    
}

.r-box:before, .r-box:after, .box-border:before, .box-border:after{
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    

}
.box-border{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
}
.r-box:before{
    border-top: 5px solid #1B5BDC;
    border-left: 5px solid #1B5BDC;
    left: -3px;
    top: -3px;
}
.r-box:after{
    border-top: 5px solid #1B5BDC;
    border-right: 5px solid #1B5BDC;
    right: -3px;
    top: -3px;
}
.box-border:before{
    border-bottom: 5px solid #1B5BDC;
    border-left: 5px solid #1B5BDC;
    left: -3px;
    bottom: -3px;
}
.box-border:after{
    border-bottom: 5px solid #1B5BDC;
    border-right: 5px solid #1B5BDC;
    right: -3px;
    bottom: -3px;
}
.height-icon{
    width: 33rem;
    margin-right: 9rem;
}
.r-box2{
    width: 560rem;
    height: 456rem;
    box-sizing: border-box;
}
.detail-img{
    width: 100%;
    /* top: 0; */
    /* left: 0; */
    animation: block-ani 4000ms linear infinite;
}
@keyframes block-ani {
    0%{
        margin-top: -18rem;
    }
    50%{
        margin-top: 0rem
    }
    100%{
        margin-top: -18rem;
    }
}
.shadow{
    position: absolute;
    /* height: 184px; */
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    animation: shadow-ani1 1000ms linear,shadow-ani2 4000ms linear infinite;
}
@keyframes shadow-ani1 {
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}
@keyframes shadow-ani2 {
    0%{
        width: 560rem;
    }
    50%{
        /* 560*0.7 */
        width: 392rem
    }
    100%{
        width: 560rem;
    }
}
.height-num{
    font-family: akrobat;
    font-size: 48rem;
    font-weight: 600;
    flex: 1;
    text-align: right;
    line-height: 60rem;
}
.info-box{
    padding-top: 16rem;
}
.label{
    margin-top: 32rem;
    color: #6A6C78;
    font-size: 17.6rem;
    line-height: 26.4rem;
}
.value{
    font-family: akrobat;
    font-size: 25.6rem;
    font-weight: 600;
    line-height: 38.4rem;
    word-break: break-all;
    margin-top: 7rem;
}
.label-last, .value-last{
    margin-left: 367rem;
}
.label-last{
    margin-top: -74rem;
}

</style>